import qs from 'query-string';

import CreditorService from '-/services/CreditorService';
import StipsService from '-/services/StipsService';
import CallbackService from '-/services/CallbackService';
import DealInfoService from '-/services/DealInfoService';
import DocumentService from '-/services/DocumentService';
import UIService from '-/services/UIService';
import {getCreditorBySegment, getInfo, getPartialInfo} from '-/api/api';
import {getOfferId, getPIN, isNewOffer} from '-/util/util';
import {UI_INITIALIZE, PIN_DISCOVERY_FAILURE} from '-/actions/types';
import BuyerInfoService from '-/services/BuyerInfoService';
import NavigationService from '-/services/NavigationService';
import SessionService from '-/services/SessionService';
import VehicleInfoService from '-/services/VehicleInfoService';
import {get, pick} from '-/util/lodash';

const queryParams = qs.parse(location.search);

let {creditorId} = queryParams;
const {segmentId} = queryParams;

const dispatchError = (dispatch, data) => {
    UIService.setError({
        title: 'Cannot Load Application',
        ...data
    });
};

const validateFetchInfoData = (dispatch, data) => {
    let content = [];

    ({data} = data.data);
    if (!data) {
        content.push('No data.');
    } else {
        if (!data.config) {
            content.push('No config object.');
        }
        if (!data.dealInfo) {
            content.push('No deal info object.');
        }
        if (!data.buyerInfo) {
            content.push('No buyer info object.');
        }
        if (!data.navigation) {
            content.push('No navigation object.');
        }
    }
    if (content.length) {
        dispatchError(dispatch, {content});
    }

    return !content.length;
};

export const fetchInfo = () => {
    return dispatch => {
        return new Promise(async(resolve, reject) => {
            const offerId = getOfferId();
            const pin = getPIN();
            const isNew = isNewOffer(offerId);

            const handlePartialInfo = info => {
                const {data} = info.data;
                const {config} = data;

                dispatch({
                    type: UI_INITIALIZE,
                    value: {
                        ...data,
                        config: {
                            ...config,
                            ...offerId && !isNew && {offerId}
                        }
                    }
                });

                CallbackService.setData(data.creditor.callback);
                CreditorService.setData(data.creditor);
            };

            const handleError = err => {
                let error = true;
                if (err.response) {
                    const {data} = err.response;
                    if (data && data.error) {
                        ({error} = data);
                    }
                }

                dispatchError(dispatch, error);
                reject(error);
            };

            if ((offerId && !isNew) || pin) {
                const params = {
                    ...offerId && {offerId},
                    ...pin && {pin}
                };

                getInfo(params).then(info => {
                    const {data, userInfo} = info.data;
                    const userData = pick(userInfo, ['_id', 'isCCR', 'name']);

                    if (validateFetchInfoData(dispatch, info)) {
                        dispatch({
                            type: UI_INITIALIZE,
                            value: info.data.data
                        });

                        DocumentService.setData(data.documents);
                        StipsService.setData(data.stips);
                        NavigationService.setData(data.navigation);
                        BuyerInfoService.setData(pick(data, ['buyerInfo', 'buyerInfo_CoApp']));
                        CallbackService.setData(data.creditor.callback);
                        CreditorService.setData(data.creditor);
                        DealInfoService.setData(data.dealInfo);
                        UIService.initialize(data.status);
                        SessionService.initialize(userData);
                        VehicleInfoService.setData(data.vehicleInfo);
                    }

                    resolve();
                }).catch(ex => {
                    const isCustomError = get(ex, 'response.data.error.isCustomError', false);

                    getPartialInfo(creditorId).then(info => {
                        handlePartialInfo(info);

                        if (pin) {
                            dispatch({
                                type: PIN_DISCOVERY_FAILURE
                            });

                            NavigationService.next('pin');

                            resolve();
                        }

                        if (isCustomError) {
                            handleError(ex);
                        } else {
                            // Remove `offerDiscovered` key in case it has been set
                            // If we get here, the offerId is invalid and we loop forever if we keep the key intact :yikes:
                            localStorage.removeItem('offerDiscovered');
                            window.location.href = '/';
                        }

                        resolve();
                    }).catch(err => {
                        localStorage.removeItem('offerDiscovered');
                        handleError(err);
                    });
                });
            } else {
                if (segmentId) {
                    if (!creditorId) {
                        ({creditorId} = await getCreditorBySegment(segmentId));
                    }
                }
                getPartialInfo(creditorId).then(info => {
                    handlePartialInfo(info);

                    resolve();
                }).catch(handleError);
            }
        });
    };
};
